// extracted by mini-css-extract-plugin
export default {"button":"Button_button__JBBzO","selected":"Button_selected__NZP20"};